import { render, staticRenderFns } from "./adoptSchoolManager.vue?vue&type=template&id=fad7aef2"
import script from "./adoptSchoolManager.vue?vue&type=script&lang=js"
export * from "./adoptSchoolManager.vue?vue&type=script&lang=js"
import style0 from "./adoptSchoolManager.vue?vue&type=style&index=0&id=fad7aef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports